"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  en: {
    filterByLabel: 'Filter by %{filterCategory}:',
    applyButtonLabel: 'Apply',
    clearButtonLabel: 'Clear'
  },
  fr: {
    filterByLabel: 'Filtrer par %{filterCategory}:',
    applyButtonLabel: 'Appliquer',
    clearButtonLabel: 'Effacer'
  }
};